import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SiteHeader from '../components/SiteHeader';
import SiteFooter from '../components/SiteFooter';
import { trackEvent } from '../components/Analytics';

const CATEGORIES = [
  { id: 'all', label: 'All', emoji: '✨' },
  { id: 'kids', label: 'Kids', emoji: '🧒' },
  { id: 'food', label: 'Food', emoji: '🍎' },
  { id: 'animals', label: 'Animals', emoji: '🐶' },
  { id: 'planet', label: 'Planet', emoji: '🌎' },
  { id: 'health', label: 'Health', emoji: '❤️‍🩹' },
  { id: 'community', label: 'Community', emoji: '🏘️' },
  { id: 'world', label: 'World', emoji: '🌍' },
  { id: 'pride', label: 'Pride', emoji: '🏳️‍🌈' },
];

const CHARITIES = [
  // Kids
  { category: 'kids', emoji: '🏥', name: 'SickKids Foundation', desc: "SickKids is a famous hospital in Toronto just for kids. Your dough helps doctors and scientists fix broken bones, fight big sicknesses, and find new cures for children.", url: 'https://www.sickkidsfoundation.com/donate' },
  { category: 'kids', emoji: '💬', name: 'Kids Help Phone', desc: "For the youth of Canada who believe everyone deserves to Feel Out Loud, Kids Help Phone is the 'Unlock The Hope' Youth Charity, the Empowering, Trusted Changemaker, that delivers a personalized well-being experience for all youth, so they can thrive in their world, no matter where life takes them.", url: 'https://kidshelpphone.ca/get-involved/donate/' },
  { category: 'kids', emoji: '⭐', name: 'Make-A-Wish Canada', desc: "Make-A-Wish grants dream-come-true wishes for kids who are very sick — like meeting a hero or going on an adventure. Your dough helps turn a hard time into a magical memory.", url: 'https://makeawish.ca/donate/' },
  { category: 'kids', emoji: '⚽', name: 'Canadian Tire Jumpstart', desc: "Every kid deserves to play sports, but gear and sign-up fees cost money some families don't have. Your dough helps kids join teams, get equipment, and play!", url: 'https://jumpstart.canadiantire.ca/pages/donate' },
  { category: 'kids', emoji: '🏅', name: 'Special Olympics Canada', desc: "Special Olympics helps athletes with intellectual disabilities train, compete, and win medals in sports all year round. Your dough cheers them all the way to the finish line.", url: 'https://www.specialolympics.ca/donate' },
  // Food
  { category: 'food', emoji: null, logo: '/food-banks-canada-logo.png', name: 'Food Banks Canada', desc: "Food banks near you give groceries to families when money is tight. Your dough helps fill food bank shelves and dinner plates right in your own community and across Canada.", url: 'https://foodbankscanada.ca/give/' },
  { category: 'food', emoji: '🥞', name: 'Breakfast Club of Canada', desc: "It's hard to learn on an empty tummy! Your dough helps schools serve a healthy breakfast so every kid starts the day ready to go.", url: 'https://www.breakfastclubcanada.org/individual-donations/' },
  { category: 'food', emoji: '♻️', name: 'Second Harvest', desc: "Lots of perfectly good food gets thrown away — Second Harvest rescues it and delivers it to people who need it. Your dough keeps good food out of the garbage and on the table.", url: 'https://www.secondharvest.ca/donate' },
  // Animals
  { category: 'animals', emoji: '🐾', name: 'Humane Canada', desc: "Humane Canada teams up with animal shelters and SPCAs across the country to keep pets safe from harm. Your dough helps protect dogs, cats, and all kinds of animals.", url: 'https://humanecanada.ca/en/ways-to-give' },
  { category: 'animals', emoji: '🐻‍❄️', name: 'WWF-Canada', desc: "WWF-Canada protects amazing wild animals like polar bears, whales, and caribou — and the wild places they live. Your dough helps keep them safe for the future.", url: 'https://wwf.ca/donate/' },
  // Planet
  { category: 'planet', emoji: '🦊', name: 'Earth Rangers', desc: "Earth Rangers is a conservation club just for kids — with missions, animal adoptions, and cool school visits. Your dough powers kid-sized projects that protect animals and the planet.", url: 'https://www.earthrangers.com/EN/CA/donate/' },
  { category: 'planet', emoji: '🌳', name: 'Tree Canada', desc: "Trees clean our air, shade our parks, and give animals homes. Your dough plants real trees in real neighbourhoods across Canada.", url: 'https://treecanada.ca/donate/' },
  { category: 'planet', emoji: '🏞️', name: 'Nature Conservancy of Canada', desc: "NCC protects Canada's most special wild places — forests, prairies, and wetlands — so they stay wild forever. Your dough helps save nature, acre by acre.", url: 'https://natureconservancy.ca/' },
  { category: 'planet', emoji: '🐋', name: 'Ocean Wise', desc: "Oceans are home to whales, seals, and millions of fish — and they need our help. Your dough supports scientists working to keep our oceans clean and full of life.", url: 'https://ocean.org/action/ways-to-give/' },
  // Health
  { category: 'health', emoji: '🏃', name: 'Terry Fox Foundation', desc: "Terry Fox ran across Canada on one leg to fight cancer, and his run never stopped. Your dough joins his Marathon of Hope by helping scientists find cures.", url: 'https://terryfox.org/?form=GENERAL' },
  { category: 'health', emoji: '❤️', name: 'Heart & Stroke', desc: "Your heart beats about 100,000 times a day — it's a big job! Your dough helps doctors learn how to keep hearts and brains healthy and strong.", url: 'https://www.heartandstroke.ca/how-you-can-help/ways-to-give' },
  { category: 'health', emoji: '🎗️', name: 'Canadian Cancer Society', desc: "The Canadian Cancer Society helps people who are sick with cancer and funds scientists hunting for cures. Your dough brings help and hope to families across Canada.", url: 'https://cancer.ca/en/ways-to-give' },
  { category: 'health', emoji: '🦮', name: 'CNIB Foundation', desc: "CNIB helps people who are blind or can't see well live big, full lives — even training amazing guide dogs. Your dough opens doors and guides the way.", url: 'https://www.cnib.ca/en/support-us/give' },
  { category: 'health', emoji: '🦾', name: 'The War Amps — CHAMP', desc: "The War Amps CHAMP program helps kids who are missing arms or legs get artificial limbs so they can run, swim, and play. Your dough helps a kid just like you do what they love.", url: 'https://donate.waramps.ca/eforms.aspx?edonate' },
  // Community
  { category: 'community', emoji: '🤝', name: 'United Way', desc: "United Way helps people right in your own community — with food, shelter, and someone to lean on. Your dough stays close to home, helping neighbours in need.", url: 'https://www.unitedway.ca/donate/' },
  { category: 'community', emoji: '🧢', name: 'Big Brothers Big Sisters of Canada', desc: "Every kid deserves a mentor — a big buddy who listens, helps with homework, and shows up. Your dough matches kids with mentors who change their lives.", url: 'https://bigbrothersbigsisters.ca/donate-online/' },
  { category: 'community', emoji: '🔨', name: 'Habitat for Humanity Canada', desc: "Habitat helps working families build and buy homes of their very own. Your dough buys nails, wood, and hope — one house at a time.", url: 'https://habitat.ca/en/how-you-can-help/ways-to-give' },
  // World
  { category: 'world', emoji: '⛑️', name: 'Canadian Red Cross', desc: "When floods, fires, or emergencies happen, the Red Cross rushes in to help — in Canada and around the world. Your dough brings blankets, food, and safety when people need it most.", url: 'https://donate.redcross.ca' },
  { category: 'world', emoji: '🌐', name: 'UNICEF Canada', desc: "UNICEF helps children in almost every country on Earth get medicine, clean water, and school. Your dough travels the world to help kids everywhere.", url: 'https://www.unicef.ca/en/donate' },
  // Pride
  { category: 'pride', emoji: '🌈', name: 'Egale Canada', desc: "Egale works so LGBTQ+ people — all kinds of families and love — are treated fairly and kindly everywhere in Canada. Your dough helps make schools and communities safer places to be yourself.", url: 'https://egale.ca/donate/' },
  { category: 'pride', emoji: null, logo: '/the-519-logo.jpeg', name: 'The 519', desc: "The 519 is Canada's largest community centre located in Toronto. It's where 2SLGBTQ+ communities, including families and kids can meet, find belonging, and grow together through storytime, songs, celebrations, and more. Your dough helps ensure this 50-year-old organization can continue to provide a safer and welcoming space for all 2SLGBTQ+ people.", url: 'https://www.the519.org/donate/' },
  { category: 'pride', emoji: null, logo: '/rainbow-railroad-logo.webp', name: 'Rainbow Railroad', desc: "In some parts of the world, it isn't safe to be LGBTQ+. Rainbow Railroad helps people facing danger find a safer place where they can live freely and be themselves. Your dough helps support their journey to safety.", url: 'https://www.rainbowrailroad.org/donate' },
];

const CATEGORY_META = {
  kids: { heading: 'Kids', sub: 'helps kids near you and across Canada' },
  food: { heading: 'Food', sub: 'helps feed families and kids' },
  animals: { heading: 'Animals', sub: 'helps protect animals big and small' },
  planet: { heading: 'Planet', sub: 'helps protect nature and our planet' },
  health: { heading: 'Health', sub: 'helps people stay healthy and strong' },
  community: { heading: 'Community', sub: 'helps neighbours right in your community' },
  world: { heading: 'World', sub: 'helps people all around the world' },
  pride: { heading: 'Pride', sub: 'helps LGBTQ+ people feel safe, seen, and supported' },
};

function CharityCard({ charity }) {
  return (
    <div className="ch-card" data-testid={`charity-${charity.name.replace(/\s+/g, '-').toLowerCase()}`}>
      <div className={`ch-card-emoji${charity.logo ? ' ch-card-logo-lg' : ''}`}>
        {charity.logo
          ? <img src={charity.logo} alt={charity.name} className="ch-card-logo" />
          : charity.emoji}
      </div>
      <div className="ch-card-body">
        <h3 className="ch-card-name">{charity.name}</h3>
        <p className="ch-card-desc">{charity.desc}</p>
        <a
          href={charity.url}
          target="_blank"
          rel="noopener noreferrer"
          className="ch-card-link"
          onClick={() => trackEvent('charity-visit', '/charities', charity.name)}
          data-testid={`donate-${charity.name.replace(/\s+/g, '-').toLowerCase()}`}
        >
          Visit / Donate ↗
        </a>
      </div>
    </div>
  );
}

export default function CharitiesPage() {
  const navigate = useNavigate();
  const [filter, setFilter] = useState('all');

  const filtered = filter === 'all' ? CHARITIES : CHARITIES.filter(c => c.category === filter);
  const groupedCategories = filter === 'all'
    ? Object.keys(CATEGORY_META)
    : [filter];

  return (
    <div className="landing-page" data-testid="charities-page">
      <SiteHeader />

      {/* Hero */}
      <section className="ch-hero" data-testid="charities-hero">
        <div className="container ch-hero-inner">
          <h1 className="ch-hero-h1">Making a difference through Dough'Nation</h1>
          <p className="ch-hero-tagline">Kids with heart, giving back.</p>
          <p className="ch-hero-body">
            BuckTime!'s <strong>Dough'Nate</strong> lets kids turn some of what they earn into a real
            donation to a cause they care about. Here are the registered Canadian
            charities families can choose from.
          </p>
          <div className="ch-hero-btns">
            <button
              className="lp-play-badge"
              onClick={() => { window.open('https://get.bucktime.ca/android?src=charities-hero', '_blank'); }}
            >
              <img src="/google-play-badge-trimmed.png" alt="Get it on Google Play" className="play-badge-img" style={{width: '200px', height: '60px', objectFit: 'contain'}} />
            </button>
            <button
              className="lp-play-badge"
              onClick={() => { window.open('https://get.bucktime.ca/ios?src=charities-hero', '_blank'); }}
            >
              <img src="/app-store-badge.svg" alt="Download on the App Store" className="play-badge-img" style={{width: '200px', height: '60px', objectFit: 'contain'}} />
            </button>
            <a href="#how-it-works" className="ch-btn-secondary" data-testid="charities-how-it-works">
              How it works
            </a>
          </div>
        </div>
      </section>

      {/* How Dough'Nate works */}
      <section className="ch-how" id="how-it-works" data-testid="charities-how">
        <div className="container ch-how-inner">
          <h2 className="ch-section-h2">How Dough'Nate works</h2>
          <div className="ch-steps">
            <div className="ch-step" data-testid="step-1">
              <span className="ch-step-num">1</span>
              <h3 className="ch-step-title">Kids earn and set some aside.</h3>
              <p className="ch-step-desc">As kids build good money habits in BuckTime!, they can put part of what they earn into a <strong>Give jar</strong>.</p>
            </div>
            <div className="ch-step" data-testid="step-2">
              <span className="ch-step-num">2</span>
              <h3 className="ch-step-title">Kids pick a cause.</h3>
              <p className="ch-step-desc">From the shelf below, a child chooses a charity that matters to them — and learns a little about the good it does.</p>
            </div>
            <div className="ch-step" data-testid="step-3">
              <span className="ch-step-num">3</span>
              <h3 className="ch-step-title">Parents make the real donation.</h3>
              <p className="ch-step-desc">The child's request goes to their parent, who makes the actual donation directly to the charity with their own card — and gets the tax receipt.</p>
            </div>
          </div>
          <div className="ch-how-note" data-testid="charities-safe-note">
            <p>
              <strong>The app never moves money to a charity.</strong> BuckTime! inspires and directs the
              gift; every real donation is made by a parent, straight to the charity. That
              keeps giving safe, transparent, and in the family's hands.
            </p>
          </div>
        </div>
      </section>

      {/* Charity Shelf */}
      <section className="ch-shelf" data-testid="charities-shelf">
        <div className="container ch-shelf-inner">
          <h2 className="ch-section-h2">The charity shelf</h2>

          {/* Filter chips */}
          <div className="ch-filters" data-testid="category-filters">
            {CATEGORIES.map(cat => (
              <button
                key={cat.id}
                className={`ch-chip ${filter === cat.id ? 'ch-chip-active' : ''}`}
                onClick={() => { setFilter(cat.id); trackEvent('charity-filter', '/charities', cat.id); }}
                data-testid={`filter-${cat.id}`}
              >
                <span className="ch-chip-emoji">{cat.emoji}</span>
                {cat.label}
              </button>
            ))}
          </div>

          {/* Categories + cards */}
          {groupedCategories.map(catId => {
            const meta = CATEGORY_META[catId];
            const catCharities = filtered.filter(c => c.category === catId);
            if (catCharities.length === 0) return null;
            const catInfo = CATEGORIES.find(c => c.id === catId);
            return (
              <div key={catId} className="ch-category" data-testid={`category-${catId}`}>
                <h3 className="ch-cat-heading">
                  <span className="ch-cat-emoji">{catInfo?.emoji}</span>
                  {meta.heading} <span className="ch-cat-sub">— {meta.sub}</span>
                </h3>
                <div className="ch-cards">
                  {catCharities.map(charity => (
                    <CharityCard key={charity.name} charity={charity} />
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* Closing CTA */}
      <section className="ch-closing" data-testid="charities-closing-cta">
        <div className="container ch-closing-inner">
          <h2 className="ch-closing-h2">Raising a little philanthropist?</h2>
          <p className="ch-closing-body">
            BuckTime! turns everyday earning into lessons in saving, spending, and giving.
          </p>
          <div className="lp-hero-btns" style={{ justifyContent: 'center' }}>
            <button
              className="lp-play-badge"
              onClick={() => { window.open('https://get.bucktime.ca/android?src=charities-footer', '_blank'); }}
            >
              <img src="/google-play-badge-trimmed.png" alt="Get it on Google Play" className="play-badge-img" style={{width: '200px', height: '60px', objectFit: 'contain'}} />
            </button>
            <button
              className="lp-play-badge"
              onClick={() => { window.open('https://get.bucktime.ca/ios?src=charities-footer', '_blank'); }}
            >
              <img src="/app-store-badge.svg" alt="Download on the App Store" className="play-badge-img" style={{width: '200px', height: '60px', objectFit: 'contain'}} />
            </button>
          </div>
        </div>
      </section>

      {/* Disclaimer */}
      <div className="ch-disclaimer" data-testid="charities-disclaimer">
        <div className="container">
          <p>
            BuckTime! is not affiliated with, and does not imply endorsement by, any
            charity listed on this page. Charity names, logos, and trademarks are the
            property of their respective owners and are used to identify the organizations
            families may choose to support. Donations are made by parents directly to each
            charity; BuckTime! does not collect, hold, or transmit donations, and does not
            issue tax receipts. Charity information is provided for general guidance and may
            change. To have your organization's listing updated or removed, contact{' '}
            <a href="mailto:partnerships@bucktime.ca">partnerships@bucktime.ca</a>.
          </p>
        </div>
      </div>

      <SiteFooter />
    </div>
  );
}
